/** Формат дат и сумм. Локаль одна - ru-RU, приложение одноязычное. */

const NUMBER_FORMAT = new Intl.NumberFormat('ru-RU');

/** ISO-дата (2026-05-27) в вид 27.05.2026. */
export const formatDate = (iso: string): string => {
  const [year, month, day] = iso.split('-');
  if (!year || !month || !day) return iso;
  return `${day}.${month}.${year}`;
};

export const formatNumber = (value: number): string =>
  NUMBER_FORMAT.format(value);

const KOPECK_FORMAT = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Сумма в рублях: целая - без копеек (37 000 ₽), иначе с двумя знаками (3 083,40 ₽). */
export const formatMoney = (value: number): string =>
  `${(Number.isInteger(value) ? NUMBER_FORMAT : KOPECK_FORMAT).format(value)} ₽`;

/** Число в поле ввода - с запятой, как его набирает менеджер: 154,17. */
export const formatDecimalInput = (value: number | string): string =>
  String(value).replace('.', ',');

/**
 * Число из ответа API. Числа приходят как number | string: бэкенд принимает их и
 * строками (JsonSerializerDefaults.Web), и спека это честно отражает.
 */
export const toNumber = (value: number | string): number => Number(value);

/**
 * Количество с единицей хранения из 1С: «25 шт», «2,5 кг». Без единицы - одно
 * число. Пробелы по краям единицы срезаются: в УТ встречается «л ».
 */
export const formatQuantity = (
  quantity: number | string,
  unitName?: string | null,
): string => {
  const value = formatNumber(toNumber(quantity));
  const unit = unitName?.trim();

  return unit ? `${value} ${unit}` : value;
};

/** Размер файла для людей: 812 Б, 106 КБ, 1,4 МБ. */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${formatNumber(bytes)} Б`;
  if (bytes < 1024 * 1024)
    return `${formatNumber(Math.round(bytes / 1024))} КБ`;

  return `${formatNumber(Math.round((bytes / 1024 / 1024) * 10) / 10)} МБ`;
};

/** Момент времени из API (ISO с часовым поясом) в дату по местному времени: 01.10.2026. */
export const formatInstantDate = (iso: string): string =>
  new Date(iso).toLocaleDateString('ru-RU');

/** Момент времени из API в дату и время по местному времени: 01.10.2026, 09:12. */
export const formatInstantDateTime = (iso: string): string =>
  new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
